import React, { Component } from 'react';
import Modal from 'react-responsive-modal';
import {number_format,number_input_format} from '../helper/format';
import $ from 'jquery';

export default class Usimpopup extends Component {
    constructor(props)
    {
        super(props);
        this.state = {
            open: false,
            select_index: 0,
            usims: []
        }
    }
    Open(selected_usimOption)
    {
        this.setState({
            open: true,
            select_index: selected_usimOption.index
        });

        this.requestData();
    }
    Close()
    {
        this.setState({
            open: false
        });
    }
    Apply(item, index)
    {
        let usim = {};
        const dText = ["일시납/후납","대납","기존유심 사용"];
        if( item == 0 ) {
            usim.display = "";
            usim.price = "미적용";
            usim.index = 0;
            usim.idx = 0;
        } else {
            usim.display = item.name;
            usim.price = item.price;
            usim.index = index;
            usim.idx = item.idx;
        }
        this.props.onUsimChanged(usim);
        this.Close();
    }
    requestData()
    {
      const self = this;
      $.post('https://api.tfamily.co.kr/api/mobile/base',
      {},
      function(data){
          const parsedData = JSON.parse(data);
          let usims = parsedData.data.usim;
          self.setState({
            usims: usims
          })
      });
    }
    render()
    {
        const self = this;
        return (
            <Modal open={this.state.open} onClose={()=>{self.Close()}} center>
                <div className="modal-dialog modal-sm mb0">
                    <div className="popupPadding ">
                        <div className="md-popup-header"> &nbsp;유심</div>
                        <div className="md-popup-contents pt0 pl0">
                            <table className="table priceTable">
                                <tbody>
                                    <tr key={0} className={(self.state.select_index==0) ? 'priceSelect' : ''} onClick={()=>{self.Apply(0);}}>
                                        <td>미적용</td>
                                    </tr>
                                    {self.state.usims.map((item,index)=>{
                                      return <tr className={(self.state.select_index==(index+1)) ? 'priceSelect' : ''} key={item.idx} onClick={()=>{self.Apply(item,index+1)} }>
                                        <td>{item.name}</td>
                                      </tr>
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}
